import { render, staticRenderFns } from "./WidgetBreadcrumbs.vue?vue&type=template&id=17f27559&scoped=true"
import script from "./WidgetBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./WidgetBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./WidgetBreadcrumbs.vue?vue&type=style&index=0&id=17f27559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f27559",
  null
  
)

export default component.exports